export default "/_next/static/chunks/fonts/MinionPro-It-9665829f822f175aa0bf9fa49f5aaabc.woff";